import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function fancyText(): ComponentStyle {
  return {
    componentName: 'fancyText',
    baseStyle: {
      width: 'fit-content',
      fontWeight: 600
    },
    variants: {
      gradientPrimary: {
        color: 'transparent',
        backgroundImage: 'linear-gradient(90deg,#fd25b5,#ffc42c)',
        backgroundClip: 'text'
      },
      gradientOrange: {
        color: 'transparent',
        backgroundImage: 'linear-gradient(90deg,#ff895d,#ffe6a4 50%,#fff)',
        backgroundClip: 'text'
      },
      gradientPurple: {
        color: 'transparent',
        backgroundImage: 'linear-gradient(90deg,#7a6bff,#bddeff 50%,#fff)',
        backgroundClip: 'text'
      },
      gradientMagenta: {
        color: 'transparent',
        backgroundImage: 'linear-gradient(90deg,#fa43bd,#ffb5b5 50%,#fff)',
        backgroundClip: 'text'
      },
      gradientGreen: {
        color: 'transparent',
        backgroundImage: 'linear-gradient(90deg,#00c2a1,#57f7d5 50%,#fff)',
        backgroundClip: 'text'
      }
    }
  };
}
